import { ScrollCarousel } from 'theme';

class CustomScrollCarouselButtons extends ScrollCarousel {
  constructor() {
    super();
  }

  connectedCallback() {
    if (super.connectedCallback) {
      super.connectedCallback();
    }

    this.settings = {
      carouselSelector: this.getAttribute('aria-controls') || null
    };

    this.dom = {
      carousel: document.getElementById(this.settings.carouselSelector),
      previousButton: this.querySelector('.product-gallery__custom-nav-button--previous'),
      nextButton: this.querySelector('.product-gallery__custom-nav-button--next'),
    };

    if (!this.dom.carousel) {
      console.error('Carousel not found');
      return;
    }

    this.setButtonState();
    this.addEventListeners();
  }


  addEventListeners() {
    this.dom.previousButton.addEventListener('click', (e) => {
      this.dom.carousel.previous();
      this.setButtonState(e);
    });

    this.dom.nextButton.addEventListener('click', (e) => {
      this.dom.carousel.next();
      this.setButtonState(e);
    });
  }

  removeEventListeners() {
    this.dom.previousButton.removeEventListener('click', (e) => {
      this.dom.carousel.previous();
      this.setButtonState(e);
    });

    this.dom.nextButton.removeEventListener('click', (e) => {
      this.dom.carousel.next();
      this.setButtonState(e);
    });
  }

  setButtonState(event) {

    const isFirst = this.dom.carousel.selectedIndex === 0;
    const isLast = this.dom.carousel.selectedIndex === this.dom.carousel.cells.length - 1;

    if (isFirst) {
      this.dom.previousButton.setAttribute('disabled', true);

      if (event) {
        requestAnimationFrame(() => {
          this.dom.nextButton.focus();
        });
      }
    } else {
      this.dom.previousButton.removeAttribute('disabled');
    }

    if (isLast) {
      this.dom.nextButton.setAttribute('disabled', true);

      if (event) {
        requestAnimationFrame(() => {
          this.dom.previousButton.focus();
        });
      }
    } else {
      this.dom.nextButton.removeAttribute('disabled');
    }
  }
}

if (!window.customElements.get('custom-scroll-carousel-buttons')) {
  window.customElements.define('custom-scroll-carousel-buttons', CustomScrollCarouselButtons);
}


class VideoAutoplay extends HTMLElement {
  constructor() {
    super();

    this.videoElement = null;
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.videoElement = this.querySelector('video');
    this.videoMedia = this.querySelector('video-media');
    if (this.videoElement) {
      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0 });
      this.intersectionObserver.observe(this.videoElement);
    }

  }

  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.videoElement);
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    const isVisible = entries[0].isIntersecting;
    if (isVisible) {
      this.videoMedia.play(this.videoElement);
      console.log('play');
    } else {
      this.videoMedia.pause(this.videoElement);
      console.log('pause');
    }
  }

  playVideo() {
    if (this.videoElement) {
      this.videoElement.play();
    }
  }

  pauseVideo() {
    if (this.videoElement) {
      this.videoElement.pause();
    }
  }
}

if (!window.customElements.get('video-autoplay')) {
  customElements.define('video-autoplay', VideoAutoplay);
}
